import { isQrWaiterOrder } from "../../../services/QrWaiter";
import { siteGroups } from "..";
export const aaTestEqualSplit = {
    name: "AaTestEqualSplit",
    variants: [
        ["Control", 1],
        ["Test", 1], // Treatment
    ],
    controlVariant: "Control",
    apply: (assignVariant, clearVariant) => {
        const validEnvironment = Skubacz.configuration.environment === "production";
        const validSiteId = siteGroups.even(Skubacz.configuration.site_id);
        const validCountry = Skubacz.configuration.country === "PL";
        const validSource = !isQrWaiterOrder() && !Skubacz.Device.isMobileApp();
        if (validEnvironment && validSiteId && validCountry && validSource) {
            assignVariant();
        }
        else {
            clearVariant();
        }
    },
};
